import React from 'react';
import {
  ComponentVerticalSpacing,
  ComponentWrapper,
  Card
} from 'day8-react/build/new-components';
import PropTypes from 'prop-types';

const Partners = props => {
  const { data } = props;
  return (
    <ComponentVerticalSpacing>
      <ComponentWrapper>
        <div className="d8-l-auto-grid max-width-xs margin-auto">
          {data.map((item, i) => (
            <Card
            key={i}
              bgColor={item.bgcolor}
            >
              <div className="d8-u-color-white text-component">
                <img
                  style={{ maxWidth: 124, margin: 0 }}
                  src={item.image.url}
                  alt={item.image.title}
                />
                <h3 className="d8-u-color-white">{item.title}</h3>
                <p>{item.text}</p>
                <p className="d8-u-ls-sm d8-u-text-uppercase d8-u-text-bold text-sm">{item.subtitle}</p>
              </div>
            </Card>
          ))}
        </div>
      </ComponentWrapper>
    </ComponentVerticalSpacing>
  );
};


Partners.propTypes = {
  data: PropTypes.object
};

export default Partners;
